// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-page-controls .page-input {
	height: 100%;
	width: 4rem;
	border-left-style: none;
	border-width: thin;
	border-color: gray;
	padding-inline: 0.3rem;
}

.gallery-page-controls .page-description {
	border: gray;
	border-block-style: solid;
	border-block-width: thin;
	display: grid;
	align-items: center;
}

.gallery-page-controls .page-count {
	padding-inline: 1rem;
}

.gallery-page-controls .button-left {
	border-top-right-radius: 0%;
	border-bottom-right-radius: 0%;
	height: 100%;
	width: 100%;
}

.gallery-page-controls .button-right {
	border-top-left-radius: 0%;
	border-bottom-left-radius: 0%;
	height: 100%;
	width: 100%;
}

.gallery-page-controls .table-control {
	justify-items: right;
	place-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pagination.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,WAAW;CACX,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,wBAAwB;CACxB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,2BAA2B;CAC3B,8BAA8B;CAC9B,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;CAC7B,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;AACtB","sourcesContent":[".gallery-page-controls .page-input {\n\theight: 100%;\n\twidth: 4rem;\n\tborder-left-style: none;\n\tborder-width: thin;\n\tborder-color: gray;\n\tpadding-inline: 0.3rem;\n}\n\n.gallery-page-controls .page-description {\n\tborder: gray;\n\tborder-block-style: solid;\n\tborder-block-width: thin;\n\tdisplay: grid;\n\talign-items: center;\n}\n\n.gallery-page-controls .page-count {\n\tpadding-inline: 1rem;\n}\n\n.gallery-page-controls .button-left {\n\tborder-top-right-radius: 0%;\n\tborder-bottom-right-radius: 0%;\n\theight: 100%;\n\twidth: 100%;\n}\n\n.gallery-page-controls .button-right {\n\tborder-top-left-radius: 0%;\n\tborder-bottom-left-radius: 0%;\n\theight: 100%;\n\twidth: 100%;\n}\n\n.gallery-page-controls .table-control {\n\tjustify-items: right;\n\tplace-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
